import { memo } from 'react'
import clsx from 'clsx'
import { SxProps } from '@mui/material'
import Dropdown, { dropdownButtonClasses } from '../Dropdown'
import { FilterDropdownPopoverProps } from './FilterDropdownPopover.types'
import { filterDropdownPopoverStyles as styles } from './FilterDropdownPopover.style'

function FilterDropdownPopover({
  isSelected = false,
  label,
  buttonProps = {},
  onClear,
  popperProps = {},
  ...props
}: FilterDropdownPopoverProps) {
  const { sx: popperSx = {}, ...otherPopperProps } = popperProps
  return (
    <Dropdown
      label={label}
      wrapperProps={{
        sx: styles.dropdownWrapper,
      }}
      buttonProps={{
        disableRipple: true,
        sx: styles.dropdown,
        labelProps: { sx: styles.dropdownLabel },
        iconWrapperProps: { sx: styles.dropdownIconWrapper },
        className: clsx({ [dropdownButtonClasses.active]: isSelected }),
        enableClear: isSelected,
        onClear,
        ...buttonProps,
      }}
      contentWrapperProps={{
        sx: styles.dropdownContentWrapper,
      }}
      popperProps={{
        sx: { ...styles.dropdownPopper, ...popperSx } as SxProps,
        ...otherPopperProps,
      }}
      {...props}
    />
  )
}

export default memo(FilterDropdownPopover)
